<template>
	<div
		v-show="initiated"
		style="display: none;"
		v-if="block"
		:class="[animated ? classAnimated : classNotAnimated]"
	>
		<slot></slot>
	</div>
	<span
		v-show="initiated"
		style="display: none;"
		v-else
		:class="[animated ? classAnimated : classNotAnimated]"
	>
		<slot></slot>
	</span>
</template>

<script>
export default {
	name: "AnimatedComponent",
	props: [
		"uniqid",
		"block",
		"delay",
		"debug",
		"whenVisible",
		"visibleTop",
		"classAnimated",
		"classNotAnimated",
		"noReplay",
	],
	data() {
		return {
			initiated: false,
			animated: false,
			event: null,
			opened: false,
			cities: [],
		};
	},
	methods: {
		schedule() {
			setTimeout(() => {
				this.animated = true;
			}, this.delay);
		},
		checkPosition() {
			if (this.getActivePosition()) {
				this.schedule();

				delete window.scrollEvents[this.uniqid];
				// } else if (this.getBottomPosition()) {
				// this.animated = false;
			}
		},
		getActivePosition() {
			const rect = this.$el.getBoundingClientRect();
			const windowBottom = window.scrollY + window.innerHeight;
			let elActivator = Infinity;

			if (rect.top > 0) {
				if (this.visibleTop === true) {
					elActivator = rect.top + window.scrollY;
				} else {
					elActivator = rect.top + window.scrollY + rect.height / 3;
				}
			}

			return windowBottom >= elActivator;
		},
		getBottomPosition() {
			const rect = this.$el.getBoundingClientRect();
			const windowTop = window.scrollY;
			const windowBottom = window.scrollY + window.innerHeight;
			let elTop = Infinity;
			let elBottom = Infinity;

			if (rect.top > 0) {
				elTop = rect.top + window.scrollY;
				elBottom = rect.top + rect.height + window.scrollY;
			}

			return windowTop > elBottom || windowBottom < elTop;
		},
		init() {
			this.animated = false;
			this.initiated = true;

			if (this.whenVisible) {
				window.scrollEvents[this.uniqid] = () => {
					this.checkPosition();
				};
			}

			setTimeout(this.whenVisible ? this.checkPosition : this.schedule, 700);
		},
	},
	mounted() {
		this.init();
	},
};
</script>
